import { __decorate, __extends, __metadata } from "tslib";
import React from 'react';
import { makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import { Misc } from '@singularsystems/neo-core';
import ComponentBase from '../ComponentBase';
import { NeoReactTypes } from '../../Modules/Types';
var ContextMenu = /** @class */ (function (_super) {
    __extends(ContextMenu, _super);
    function ContextMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.iconFactory = Misc.Globals.appService.get(NeoReactTypes.Components.IconFactory);
        _this.menuRef = React.createRef();
        _this.hoverItem = null;
        _this.mouseEnter = _this.mouseEnter.bind(_this);
        makeObservable(_this);
        return _this;
    }
    ContextMenu_1 = ContextMenu;
    ContextMenu.prototype.mouseEnter = function (e, item) {
        this.hoverItem = item;
    };
    ContextMenu.prototype.afterRender = function () {
        if (this.menuRef.current) {
            var menu = this.menuRef.current;
            menu.style.left = "0";
            menu.style.top = "0";
            var width = menu.getBoundingClientRect().width, height = menu.getBoundingClientRect().height;
            var left = 0, top_1 = 0, checkLeft = 0, checkTop = 0;
            if (this.props.position) {
                left = this.props.position.x;
                top_1 = this.props.position.y;
                checkLeft = left - window.scrollX;
                checkTop = top_1 - window.scrollY;
            }
            else {
                // Position relative to parent.
                var parent_1 = menu.parentElement;
                left = parent_1.getBoundingClientRect().width;
                checkLeft = parent_1.getBoundingClientRect().right;
                top_1 = 0;
                checkTop = parent_1.getBoundingClientRect().top;
            }
            if (checkLeft + width > window.innerWidth - 17) {
                left += window.innerWidth - 17 - checkLeft - width;
            }
            if (checkTop + height > window.innerHeight - 17) {
                top_1 += window.innerHeight - 17 - checkTop - height;
            }
            menu.style.left = left + "px";
            menu.style.top = top_1 + "px";
        }
    };
    ContextMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, menuItems = _a.menuItems, position = _a.position, show = _a.show;
        if (position) {
            show = true;
        }
        return (React.createElement("div", { className: "neo-context-menu" + (show ? " show" : ""), ref: this.menuRef },
            React.createElement("div", { className: "neo-context-menu-left-strip" }),
            menuItems.map(function (item, index) { return (React.createElement("div", { key: index, className: "neo-context-menu-item" + (item.onClick || item.items ? " can-hover" : "") + (item.header ? " header" : "") + (item.items ? " has-children" : ""), onMouseEnter: function (e) { return _this.mouseEnter(e, item); }, onClick: function (e) {
                    if (item.onClick) {
                        item.onClick(e, item.data);
                        if (_this.props.onClick && !e.isDefaultPrevented()) {
                            _this.props.onClick();
                        }
                    }
                    e.stopPropagation();
                } },
                item.isDivider && React.createElement("hr", null),
                !item.isDivider && React.createElement(React.Fragment, null,
                    !item.icon && _this.iconFactory.getIconComponent("", { fixedWidth: true }),
                    item.icon && _this.iconFactory.getIconComponent(item.icon, { fixedWidth: true }),
                    item.text && React.createElement("span", { className: "neo-context-menu-text" }, item.text),
                    item.header && React.createElement("span", { className: "neo-context-menu-text" }, item.header),
                    item.items && React.createElement("i", { className: "fa-fw fa fa-angle-right child-indicator" }),
                    item.items && _this.hoverItem === item && React.createElement(ContextMenu_1, { menuItems: item.items, show: _this.hoverItem === item, onClick: _this.props.onClick })))); })));
    };
    var ContextMenu_1;
    __decorate([
        observable.ref,
        __metadata("design:type", Object)
    ], ContextMenu.prototype, "hoverItem", void 0);
    ContextMenu = ContextMenu_1 = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], ContextMenu);
    return ContextMenu;
}(ComponentBase));
export default ContextMenu;
